import { CourseActions } from './../ActionTypes';

export const setAllCourses = (courses) => ({
    type: CourseActions.SetAll,
    courses
});
